(() => {
  const mq = window.matchMedia("(max-width: 1399px)");

  function init(sectionRoot) {
    if (!mq.matches) return;

    const summary = sectionRoot.querySelector("[data-combo-summary]");
    if (!summary) return;

    // Open picker when tapping a slot (but don't hijack remove button clicks)
    summary.addEventListener("click", (e) => {
      const removeBtn = e.target.closest("[data-remove-index]");
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      const slot = e.target.closest(".combo-slot");
      if (!slot) return;
      sectionRoot.classList.add("is-mobile-picker-open");
    });

    // Close picker
    sectionRoot.querySelectorAll("[data-combo-mobile-close]").forEach((btn) => {
      btn.addEventListener("click", () => {
        sectionRoot.classList.remove("is-mobile-picker-open");
        window.scrollTo({ top: sectionRoot.offsetTop || 0, behavior: "smooth" });
      });
    });

    // Close picker after selecting a product card
    sectionRoot.addEventListener("click", (e) => {
      const card = e.target.closest("[data-combo-card]");
      if (!card) return;
      // Let main combo-builder.js handle adding; we just close the overlay.
      sectionRoot.classList.remove("is-mobile-picker-open");
      window.scrollTo({ top: sectionRoot.offsetTop || 0, behavior: "smooth" });
    });

    // If user resizes to desktop, ensure overlay closed
    mq.addEventListener?.("change", (ev) => {
      if (!ev.matches) sectionRoot.classList.remove("is-mobile-picker-open");
    });
  }

  function boot() {
    document.querySelectorAll("section.combo-builder").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
